import {backInfo} from "./project-info/reducers";
import {user} from "./user/reducers";
import {requestList} from "./request-list/reducers";
import {requestDetails} from "./request-details/reducers";
import {newRequest} from "./newRequest/reducers";
import {signedRequestInfo} from "./newRequest/reducers";
import{signing} from "./electronic-signature/reducers";
import filtersData from "./filters/reducers";
import {notaryRegistration} from "./notary-registration/reducers";

export default {
  backInfo,
  filtersData,
  newRequest,
  notaryRegistration,
  requestList,
  requestDetails,
  signedRequestInfo,
  signing,
  user
}
